import {useEffect, useState} from "react";
import { postSubjectSuggestion} from "../utils/api";
import { selectClassTitle, suggestListKey, userLoginKey} from "../config";
import Alert from 'react-bootstrap/Alert';
import {useLocation, useNavigate} from "react-router-dom";
import Meta from "../components/Meta";

const ClassValue = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const bigTitle = sessionStorage.getItem(selectClassTitle)
  const folderId = new URLSearchParams(location.search).get('folderId')
  const [showAlert, setShowAlert] = useState({"show": false, "type": "success"})
  const [starSelect, setStarSelect] = useState({"value": 5, "folderId":folderId})
  const [disableSend, setDisableSend] = useState(false)

  useEffect(() => {
    let isUnmounted = false
    //顯示評分訊息
    const getSuggestList = JSON.parse(sessionStorage.getItem(suggestListKey))
    if (getSuggestList != null) {
      const sendAgain = getSuggestList.filter((item) => item.folderId === starSelect.folderId)
      if (sendAgain.length > 0) {
        setShowAlert({"show": true, "type": "warning"})
        setDisableSend(true)
      } else {
        setShowAlert({"show": false, "type": "warning"})
        setDisableSend(false)
      }
    }
    if (sessionStorage.getItem(userLoginKey) === null && !isUnmounted) {
      navigate("/")
    }
    return () => isUnmounted = true
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  const handleSelectChange = event => {
    setStarSelect({
      "folderId":folderId,
      "value": parseInt(event.target.value)
    })
  }

  const handleSubmit = event => {
    event.preventDefault();
    // 先檢驗是否已送出評分過
    let getSuggestList = JSON.parse(sessionStorage.getItem(suggestListKey))
    if (getSuggestList != null) {
      const sendAgain = getSuggestList.filter((item) => item.folderId === starSelect.folderId)
      if (sendAgain.length > 0) {
        setShowAlert({"show": true, "type": "warning"})
        setDisableSend(true)
        return
      }
    }

    postSubjectSuggestion(starSelect).then(
      (res) => {
        console.log("get article response:", res);
        const suggestList = [starSelect]
        if (getSuggestList === null) {
          getSuggestList = []
        }

        const newOBj = [...getSuggestList, ...suggestList]
        sessionStorage.setItem(suggestListKey, JSON.stringify(newOBj))
        setShowAlert({"show": true, "type": "success"})
        setDisableSend(true)
      },
      (e) => {
        console.log("get response failed!");
      })

  }

  return (
    <main id="main">
      <Meta title="單元評價"/>
      <section className="breadcrumbs">
        <div className="container">

          <div className="d-flex justify-content-between align-items-center">
            <h2 aria-current="page">{bigTitle}</h2>
            <ol aria-label="Breadcrumb" role="navigation">
              <li><a href="/classFirst" title="回到課程列表" role="button" tabIndex="1">回到課程列表</a></li>
              <li><a href="javascript:history.back()" title="回上一頁" role="button" tabIndex="1">回上一頁</a></li>
            </ol>
          </div>

        </div>
      </section>

      <a className="accesskey" href="#aC" id="aC" accessKey="C" title="中間主要內容區，此區塊列有本網站的主要內容" tabIndex="2">:::</a>
      <section className="grade">
        <div className="footer-newsletter">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-12">
                <h3>單元評價</h3>
                {showAlert.show ?
                  <Alert key="success" variant={showAlert.type}>
                    {showAlert.type === "success" ? "評分已成功送出，請勿重覆操作。" : "此課程已評分過，請勿重覆操作。"}
                    <Alert.Link href="/suggestion" title="點我看評分結果" tabIndex="2">點我看評分結果 </Alert.Link>
                  </Alert> : null}
                <form className="row gy-2 gx-4" onSubmit={handleSubmit}>
                  <fieldset  className="row gy-2 gx-4"   style={{ border: 0, padding: 0, margin: 0, width: "100%" }}>
                    <legend className="visually-hidden">
                      單元評價，請選擇 1 至 5 顆星
                    </legend>
                    {/* 5 顆星 */}
                    <div className="form-check col-2">
                      <label htmlFor="star5" className="font12em"  style={{ cursor: disableSend ? "default" : "pointer" }}>
                        <input className="form-check-input" type="radio" name="star" id="star5" value="5" aria-label="5 顆星"
                          onChange={handleSelectChange} disabled={disableSend} required checked={starSelect.value === 5} />
                        <span aria-hidden="true">
                          <i className="bx bxs-star"></i>
                          <i className="bx bxs-star"></i>
                          <i className="bx bxs-star"></i>
                          <i className="bx bxs-star"></i>
                          <i className="bx bxs-star"></i>
                        </span>
                      </label>
                    </div>

                    {/* 4 顆星 */}
                    <div className="form-check col-2">
                      <label htmlFor="star4" className="font12em" style={{ cursor: disableSend ? "default" : "pointer" }}>
                        <input className="form-check-input" type="radio" name="star" id="star4" value="4" aria-label="4 顆星"
                          onChange={handleSelectChange} disabled={disableSend} checked={starSelect.value === 4} />
                        <span aria-hidden="true">
                          <i className="bx bxs-star"></i>
                          <i className="bx bxs-star"></i>
                          <i className="bx bxs-star"></i>
                          <i className="bx bxs-star"></i>
                        </span>
                      </label>
                    </div>

                    {/* 3 顆星 */}
                    <div className="form-check col-2">
                      <label htmlFor="star3" className="font12em" style={{ cursor: disableSend ? "default" : "pointer" }}>
                        <input className="form-check-input" type="radio" name="star" id="star3" value="3" aria-label="3 顆星"
                          onChange={handleSelectChange} disabled={disableSend} checked={starSelect.value === 3} />
                        <span aria-hidden="true">
                          <i className="bx bxs-star"></i>
                          <i className="bx bxs-star"></i>
                          <i className="bx bxs-star"></i>
                        </span>
                      </label>
                    </div>

                    {/* 2 顆星 */}
                    <div className="form-check col-2">
                      <label htmlFor="star2" className="font12em" style={{ cursor: disableSend ? "default" : "pointer" }}>
                        <input className="form-check-input" type="radio" name="star" id="star2" value="2" aria-label="2 顆星"
                          onChange={handleSelectChange} disabled={disableSend} checked={starSelect.value === 2} />
                        <span aria-hidden="true">
                          <i className="bx bxs-star"></i>
                          <i className="bx bxs-star"></i>
                        </span>
                      </label>
                    </div>

                    {/* 1 顆星 */}
                    <div className="form-check col-2">
                      <label htmlFor="star1" className="font12em" style={{ cursor: disableSend ? "default" : "pointer" }}>
                        <input className="form-check-input" type="radio" name="star" id="star1" value="1" aria-label="1 顆星"
                          onChange={handleSelectChange} disabled={disableSend} checked={starSelect.value === 1}/>
                        <span aria-hidden="true">
                          <i className="bx bxs-star"></i>
                        </span>
                      </label>
                    </div>

                    {/* 送出 */}
                    <div className="col-2">
                      <input type="submit" value="送出" aria-label="送出課程評分" disabled={disableSend}/>
                    </div>
                  </fieldset>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  )
}

export default ClassValue
